import * as Yup from 'yup';

const BatchSearchSchema = Yup.object().shape({
    searchType: Yup.string().required(),
    searchValue: Yup.string().required().min(6),
});

export default BatchSearchSchema;